import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const NAV_LINKS = [
  { label: 'Home', href: '/#home' },
  { label: 'About', href: '/#about' },
  { label: 'Software', href: '/#software' },
  { label: 'Blog', href: '/blog' },
  { label: 'Support', href: '/support' },
  // { label: 'Contact', href: '/#contact' },
];

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
      <div className="container navbar__inner">
        <Link to="/" className="navbar__logo" onClick={handleNavClick}>
          {/* <img src="/logo.png" alt="CodeTunez Studios" className="navbar__logo-img" /> */}
          <span className="navbar__logo-text">
            CodeTunez<span className="navbar__logo-accent"> Studios</span>
          </span>
        </Link>

        <button
          className={`navbar__hamburger${menuOpen ? ' navbar__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>

        <ul className={`navbar__links${menuOpen ? ' navbar__links--open' : ''}`}>
          {NAV_LINKS.map(link => (
            <li key={link.label}>
              <Link to={link.href} className="navbar__link" onClick={handleNavClick}>
                {link.label}
              </Link>
            </li>
          ))}
          {/* <li>
            <a
              href="/#contact"
              className="navbar__cta"
              onClick={e => { e.preventDefault(); handleNavClick('/#contact'); }}
            >
              Get in Touch
            </a>
          </li> */}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
